import { render, staticRenderFns } from "./CoursesSection.vue?vue&type=template&id=5f434ad8&"
import script from "./CoursesSection.vue?vue&type=script&lang=ts&"
export * from "./CoursesSection.vue?vue&type=script&lang=ts&"
import style0 from "./CoursesSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports